import React, { useEffect, useState } from 'react';
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    Radio,
    RadioGroup,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import FieldTextAreaAutoSize from '../fields/fieldTextAreaAutoSize';
import { LabelAnswer } from './labelAnswer';

type Props = {
    title?: string;
    name: any;
    answerQuestion?: any;
    onChange: (value: any) => void;
    idQuestion?: string;
    required?: boolean;
    questionType?: string;
    whyQuestion?: boolean;
    disabled?: boolean;
    dominantColor?: string;
};

const FieldUniqueAnswer = ({
    title,
    name,
    answerQuestion,
    onChange,
    idQuestion,
    required = true,
    questionType,
    whyQuestion,
    disabled,
    dominantColor,
}: Props) => {
    const [value, setValue] = React.useState('');
    const [error, setError] = React.useState(false);
    const [helperText, setHelperText] = React.useState('');
    const [why, setWhy] = useState('');
    const [touched, setTouched] = useState(false);

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
        setHelperText(' ');
        setError(false);
        setTouched(true);
    };

    useEffect(() => {
        const isEmpty = value.length === 0;

        if (isEmpty && touched && required) {
            setHelperText('La respuesta es obligatoria');
            setError(true);
        } else {
            setError(false);
        }

        onChange({
            idQuestion,
            [name]: value,
            type: questionType,
            why: why,
            error: required && isEmpty,
        });
    }, [value, touched, why, required]);

    return (
        <>
            <Grid item xs={12} key={idQuestion}>
                <LabelAnswer
                    text={title}
                    isRequired={required}
                    dominantColor={dominantColor}
                />
                <br />
                <FormControl error={error} fullWidth>
                    <Grid display="flex" justifyContent="center">
                        <RadioGroup
                            row
                            onChange={handleRadioChange}
                            sx={{
                                textAlign: 'left',
                                border: error
                                    ? '1px solid #d32f2f'
                                    : '1px solid #E0E0E0',
                                borderRadius: '4px',
                                width: '80%',
                                '.MuiFormHelperText-root': {
                                    textAlign: 'center',
                                },
                            }}
                        >
                            {answerQuestion?.map((a: any, i: number) => (
                                <Grid item xs={6} key={a.id} px="20px">
                                    <FormControlLabel
                                        key={a.id}
                                        value={a.id}
                                        disabled={disabled ?? false}
                                        control={
                                            <Radio
                                                disabled={disabled ?? false}
                                                sx={{
                                                    color:
                                                        dominantColor || '#36c',
                                                    '&.Mui-checked': {
                                                        color:
                                                            dominantColor ||
                                                            '#36c',
                                                    },
                                                }}
                                            />
                                        }
                                        label={a.description}
                                        labelPlacement={
                                            (i + 1) % 2 === 1 ? 'start' : 'end'
                                        }
                                        slotProps={{
                                            typography: {
                                                fontFamily: 'Lucida Sans',
                                                fontSize: '14px',
                                                color: '#4b4b4b',
                                            },
                                        }}
                                        style={{
                                            display: 'flex',
                                            justifyContent:
                                                (i + 1) % 2 === 1
                                                    ? 'end'
                                                    : 'start',
                                        }}
                                    />
                                </Grid>
                            ))}
                        </RadioGroup>
                    </Grid>
                    <FormHelperText sx={{ textAlign: 'center' }}>
                        {helperText}
                    </FormHelperText>
                </FormControl>
            </Grid>
            {whyQuestion && value && (
                <Grid item xs={12}>
                    <LabelAnswer
                        text="¿Por qué?"
                        isRequired={false}
                        dominantColor={dominantColor}
                    />
                    <br />
                    <FieldTextAreaAutoSize
                        name="why"
                        placeholder="Dejanos aquí las razones de porque"
                        required={false}
                        onChange={(e: any) => setWhy(e.target.value)}
                        dominantColor={dominantColor}
                    />
                </Grid>
            )}
        </>
    );
};

export default FieldUniqueAnswer;
